export const eventCodes = [
  {
    EventCode: '0x06',
    EventDescription: 'UNKNOWN',
    EventCategory: 'Battery',
  },
  {
    EventCode: '0x07',
    EventDescription: 'LOW_BATTERY_ALARM',
    EventCategory: 'Battery',
    Issue: true,
  },
  {
    EventCode: '0x08',
    EventDescription: 'VERY_LOW_BATTERY_ALARM',
    EventCategory: 'Battery',
    Issue: true,
  },
  {
    EventCode: '0x09',
    EventDescription: 'TOO_LOW_TO_OPERATE',
    EventCategory: 'Battery',
    Issue: true,
  },
  {
    EventCode: '0x17',
    EventDescription: 'DOOR_TAMPER_ALERT',
    EventCategory: 'Battery',
    Issue: true,
  },
];
